import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetTriangle } from './useGetTriangle'
import { TriangleContent } from './TriangleContent'

export const TriangleComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetTriangle(id, tileFilterSelections)

  return (
    <TriangleContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function TriangleComponentLoading() {
  return 'Loading...'
}
